export default "__VITE_ASSET__qizJYt1X__"